import { render, staticRenderFns } from "./FormDocument.vue?vue&type=template&id=229baae2&"
import script from "./FormDocument.vue?vue&type=script&lang=js&"
export * from "./FormDocument.vue?vue&type=script&lang=js&"
import style0 from "./FormDocument.vue?vue&type=style&index=0&id=229baae2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports